import { css } from 'styled-components'

/** Usage:
import styled, { css } from 'styled-components'
import { xs, sm, md } from 'components/corpSite/components/theme/utils/media-query'
const Header = styled.h3`
  ${xs(css`
    color: red;
  `)}
  ${sm(css`
    color: tomato;
  `)}
  ${md(css`
    color: orange;
  `)}
`
 */

export const PHONE_WIDTH = 36
export const TABLET_WIDTH = 48
export const DESKTOP_WIDTH = 62
export const FULLSCREEN_WIDTH = 80

export const xs = (innerCss) => css`
  @media (max-width: ${PHONE_WIDTH - 1}em) {
    ${innerCss}
  }
`

export const sm = (innerCss) => css`
  @media (min-width: ${PHONE_WIDTH}em) {
    ${innerCss}
  }
`

export const md = (innerCss) => css`
  @media (min-width: ${TABLET_WIDTH}em) {
    ${innerCss}
  }
`

export const lg = (innerCss) => css`
  @media (min-width: ${DESKTOP_WIDTH}px) {
    ${innerCss}
  }
`

export const xsLg = (innerCss) => css`
  @media (max-width: ${DESKTOP_WIDTH - 1}em) {
    ${innerCss}
  }
`

export const smMd = (innerCss) => css`
  @media (min-width: ${PHONE_WIDTH - 1}em) and (max-width: ${TABLET_WIDTH - 1}em) {
    ${innerCss}
  }
`

export const xsMd = (innerCss) => css`
  @media (max-width: ${TABLET_WIDTH - 1}em) {
    ${innerCss}
  }
`

export const LgXl = (innerCss) => css`
  @media (min-width: ${DESKTOP_WIDTH - 1}em) and (max-width: ${FULLSCREEN_WIDTH - 1}em) {
    ${innerCss}
  }
`

export const mdLg = (innerCss) => css`
  @media (min-width: ${TABLET_WIDTH}em) and (max-width: ${DESKTOP_WIDTH}em) {
    ${innerCss}
  }
`
